export const POSTHOG_TRACKING_EVENTS = {
  AO_DRAWER_OPEN: 'ao_drawer_open',
  ASSET_OPEN: 'asset_open',
  ASSET_OVERVIEW_TAB_SELECTED: 'asset_overview_tab_selected',
  CATALYST_DRAWER_OPEN: 'catalyst_drawer_open',
  KG_BRAND_DRAWER_OPEN: 'kg_brand_drawer_open',
  KG_GEOGRAPHY_DRAWER_OPEN: 'kg_geography_drawer_open',
  CHART_OPEN: 'chart_open',
  CONNECTIONS_TAB_SELECTED: 'connections_tab_selected',
  DASHBOARD_OPEN: 'dashboard_open',
  EVENTS_DRAWER_OPEN: 'events_drawer_open',
  INSIGHTS_DRAWER_OPEN: 'insights_drawer_open',
  INSIGHTS_OPEN: 'insights_open',
  MARKET_SUMMARY_OPEN: 'market_summary_open',
  NEWS_DRAWER_OPEN: 'news_drawer_open',
  NEWS_FILTER_SELECTED: 'news_filter_selected',
  NEWS_OPEN: 'news_open',
  QUERY_SENT: 'query_sent',
  SCENARIO_OPEN: 'scenario_open',
  SCENARIO_RAN: 'scenario_ran',
  SCREENER_CREATE: 'screener_create',
  SCREENER_OPEN: 'screener_open',
  SCREENER_UPDATE: 'screener_update',
  SEARCH_OPEN: 'search_open',
  SEND_ALL_ASSETS: 'send_all_assets',
  INSIGHT_FEED_OPEN: 'insight_feed_open',
  THEME_OPEN: 'theme_open',
  THEME_OVERVIEW_DRAWER_OPEN: 'theme_overview_drawer_open',
  EVENT_PAGE_OPEN: 'event_page_open',
  TLI_DRAWER_OPEN: 'tli_drawer_open',
  WATCHLIST_CREATE: 'watchlist_create',
  WATCHLIST_OPEN: 'watchlist_open',
  WATCHLIST_TAB_SELECTED: 'watchlist_tab_selected',
  EARNINGS_INSIGHT_DRAWER_OPEN: 'earnings_insight_drawer_open',
  SCREENER_TAB_SELECTED: 'screener_tab_selected',
  INSIGHT_FEED_FILTER_SELECTED: 'insight_feed_filter_selected',
  INSIGHT_FEED_TAB_SELECTED: 'insight_feed_tab_selected',
  DASHBOARD_WHATS_NEW_TAB_SELECTED: 'dashboard_whats_new_tab_selected',
  THEME_PERFORMANCE_WIDGET_TAB_SELECTED:
    'theme_performance_widget_tab_selected',
  ALFRED_PYTHON_VIEW: 'alfred_python_view',
  ALFRED_PROCESS_VIEW: 'alfred_process_view',
  ALFRED_SHARE: 'alfred_share',
  ALFRED_PERSONALIZE: 'alfred_personalize',
  ALFRED_CHATSEARCH_OPEN: 'alfred_chatsearch_open',
  ALFRED_CHART_ACTION: 'alfred_chart_action',
  ALFRED_FLOW_OPEN: 'alfred_flow_open',
  ALFRED_PLANNING_VIEW: 'alfred_planning_view',
  ALFRED_CHAT_BOOKMARK: 'alfred_chat_bookmark',
  ALFRED_DEEP_SELECTED: 'alfred_deep_selected',
  ALFRED_WEB_SEARCH_SELECTED: 'alfred_web_search_selected',
  ALFRED_PREVIOUS_CONVERSATION_OPEN: 'alfred_previous_conversation_open',
  ALFRED_TRUSTED_SOURCE_ADDED: 'alfred_trusted_source_added',
  ALFRED_TRUSTED_SOURCE_REMOVED: 'alfred_trusted_source_removed',
  ALFRED_SOURCE_OPEN: 'alfred_source_open',
  ALFRED_CONNECTED_SERVICE_FILE_OPEN: 'alfred_connected_service_file_open',
  ALFRED_CHAT_COPY: 'alfred_chat_copy',
  ALFRED_FEEDBACK: 'alfred_feedback',
  ALFRED_CONVERSATION_PRINT: 'alfred_conversation_print',
  ALFRED_CONVERSATION_RENAME: 'alfred_conversation_rename',
  ALFRED_CONVERSATION_STARTED: 'alfred_conversation_started',
  ALFRED_DAILY_BRIEF_CARD_CLICK: 'alfred_daily_brief_card_click',
  ALFRED_DAILY_BRIEF_CARD_SHOW_MORE: 'alfred_daily_brief_card_show_more',
  ALFRED_DAILY_BRIEF_CARD_VIEW_MORE_SOURCES:
    'alfred_daily_brief_card_view_more_sources',
  ALFRED_OPENED: 'alfred_opened',
  INSIGHT_ICON_CLICKED: 'insight_icon_clicked',
  ALERTS_DROPDOWN_OPEN: 'alerts_dropdown_open',
  ALERTS_PAGE_OPEN: 'alerts_page_open',
  ALERTS_MARK_ALL_AS_READ: 'alerts_mark_all_as_read',
  ALERT_TRACKED: 'alert_tracked',
  ALERT_UNTRACKED: 'alert_untracked',
  ALFRED_CONNECT_OPEN: 'alfred_connect_open',
  SERVICE_CONNECTED: 'service_connected',
  SERVICE_DISCONNECTED: 'service_disconnected',
  SERVICE_CONNECTION_ERROR: 'service_connection_error',
  PROMPT_REFINER_OPENED: 'prompt_refiner_opened',
  PROMPT_REFINER_CLARIFICATION_ADDED: 'prompt_refiner_clarification_added',
  PROMPT_REFINER_SUGGESTION_EDITED: 'prompt_refiner_suggestion_edited',
  THEME_FOLLOWED: 'theme_followed',
  THEME_UNFOLLOWED: 'theme_unfollowed',
  GEOGRAPHY_FOLLOWED: 'geo_followed',
  GEOGRAPHY_UNFOLLOWED: 'geo_unfollowed',
  FOLLOWING_DRAWER_OPEN: 'following_drawer_open',
  FOLLOWING_TAB_VIEWED: 'following_tab_viewed',
  FOLLOWING_INSIGHT_CLICKED: 'following_insight_clicked',
} as const;

export type PosthogTrackingEventName =
  (typeof POSTHOG_TRACKING_EVENTS)[keyof typeof POSTHOG_TRACKING_EVENTS];

export const POSTHOG_TRACKING_SOURCES = {
  ALFRED: 'alfred',
  CALENDAR: 'calendar',
  CHART: 'chart',
  DASHBOARD_ALFRED: 'dashboard_alfred',
  DASHBOARD_CALENDAR: 'dashboard_calendar',
  DOCUMENT_SEARCH: 'document_search',
  DASHBOARD_TLI: 'dashboard_tli',
  DASHBOARD_WATCHLIST: 'dashboard_watchlist',
  DASHBOARD_THEME_PERFORMANCE_WIDGET: 'dashboard_theme_performance_widget',
  DASHBOARD_WHATS_NEW: 'dashboard_whats_new',
  EVENTS: 'events',
  INSIGHTS: 'insights',
  LOGIN: 'login',
  NAVIGATION_BAR: 'nav',
  NEWS: 'news',
  SCENARIO: 'scenario',
  SCENARIO_DRAWER: 'scenario_drawer',
  SCREENER: 'screener',
  SEARCH: 'search',
  INSIGHT_FEED: 'stream',
  THEME_OVERVIEW: 'theme_overview',
  TLI: 'tli',
  WATCHLIST: 'watchlist',
  WATCHLIST_MANAGER_WIDGET: 'watchlist_manager_widget',
  ASSET_OVERVIEW: 'asset_overview',
  ASSET_OVERVIEW_DRAWER: 'asset_overview_drawer',
  INVENTORY_SIDEBAR: 'inventory_sidebar',
  EARNINGS_INSIGHT_DRAWER: 'earnings_insight_drawer',
  CATALYST_INSIGHT_DRAWER: 'catalyst_insight_drawer',
  MARKET_SUMMARY_DRAWER: 'market_summary_drawer',
  THEME_OVERVIEW_DRAWER: 'theme_overview_drawer',
  ECONOMIC_EVENT_DRAWER: 'economic_event_drawer',
  SCENARIO_INSIGHT_DRAWER: 'scenario_insight_drawer',
  EMAIL: 'email',
  NEWS_DRAWER: 'news_drawer',
  GEOGRAPHIC_EXPOSURE_DRAWER: 'geographic_exposure_drawer',
  COMPETITORS_DRAWER: 'competitors_drawer',
  EARNINGS_DRAWER: 'earnings_drawer',
  CALENDAR_EVENT_DRAWER: 'calendar_event_drawer',
  COMPANY_TO_THEME_DRAWER: 'company_to_theme_drawer',
  COMPANY_TO_GEO_DRAWER: 'company_to_geo_drawer',
  THEME_TO_COMPANY_DRAWER: 'theme_to_company_drawer',
  BRAND_AND_PRODUCT_DRAWER: 'brand_and_product_drawer',
  MARKET_CATALYST_DRAWER: 'market_catalyst_drawer',
  THEME_PERFORMANCE_DRAWER: 'theme_performance_drawer',
  ALFRED_SIDE_MENU: 'alfred_side_menu',
  ALFRED_DAILY_BRIEF_CARD: 'alfred_daily_brief_card',
  ALFRED_ASSET_PREVIEW: 'alfred_asset_preview',
  ALFRED_THEME_PREVIEW: 'alfred_theme_preview',
  KEY_DEVELOPMENTS_DRAWER: 'key_developments_drawer',
  ALERTS: 'alerts',
  ALERTS_DROPDOWN: 'alerts_dropdown',
  ALFRED_CONNECTION_APPS_PANEL: 'alfred_connection_apps_panel',
  KG_INSIGHT_PAGE: 'kg_insight',
  ONBOARDING: 'onboarding',
  WHATS_NEW_WIDGET: 'what’s_new_widget',
} as const;

export type PosthogTrackingSource =
  (typeof POSTHOG_TRACKING_SOURCES)[keyof typeof POSTHOG_TRACKING_SOURCES];

export interface TrackingMetadata {
  source: PosthogTrackingSource;
  via?: PosthogTrackingSource;
}
